/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Eigentumsverhältnis)   (bipro-fahrzeug::Eigentumsverhaeltnis)     * `Policyholder`     - german: Eigentum des Versicherungsnehmers   * `Financing`        - german: Eigentum Finanzierung   * `Leasing`          - german: Leasing
 */
export const OwnershipRelationship = {
  Policyholder: 'Policyholder',
  Financing: 'Financing',
  Leasing: 'Leasing',
} as const;
export type OwnershipRelationship = (typeof OwnershipRelationship)[keyof typeof OwnershipRelationship];
